import axios from 'axios';
import TokenService from './token-service';

const aiChatbotInstance = axios.create({
  baseURL: 'https://ai-chatbot-image-3z2pxzijaq-uc.a.run.app',
  headers: {
    'Content-Type': 'application/json'
  }
});

aiChatbotInstance.interceptors.request.use(
  (config: any) => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default aiChatbotInstance;
